export default __webpack_public_path__ + "static/media/santander.6be75106.png";